var gql = require("@apollo/client").gql;

const NEWS_QUERY = gql`
	query NEWS(
		$limit: Int!
		$offset: Int!
		$filter: String!
		$withAggregate: Int
		$aggregateFilter: String
		$sort: String = "-date"
		$lastYear: Boolean
	) {
		news(limit: $limit, offset: $offset, filter: $filter, sort: $sort, last_year: $lastYear) {
			pagination {
				items_count
				items_total
				per_page
				page_current
				page_total
			}
			data {
				id
				title
				announce
				date
				text
				is_action
				image_lg
				image_preview
				provider {
					id
					name
					url_name
				}
			}
		}
		newsAggregate: news(limit: 1, filter: $aggregateFilter, with_aggregate: $withAggregate) {
			aggregation {
				providers {
					id
					translit_name
					name
				}
			}
		}
	}
`;

module.exports = NEWS_QUERY;
